import React from 'react'

export interface EmptyStateHappyProps {
  readonly darkMode?: boolean
}

const EmptyStateHappy: React.FunctionComponent<EmptyStateHappyProps> = (props) => {
  if (props.darkMode) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '100%' }} viewBox="0 0 415 313" fill="none">
        <g id="empty_state_happy">
          <g id="background">
            <path
              id="Detail"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.10781 168.983C-28.3544 60.045 66.3247 6.53701 137.533 19.4626C208.695 32.6475 196.84 67.1284 312.601 67.2011C428.14 67.1284 441.042 195.068 375.662 239.54C310.615 284.426 44.4797 277.77 8.10781 168.983Z"
              fill="#F2F2F4"
              fillOpacity="0.1"
            />
            <mask
              id="mask0"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="17"
              width="415"
              height="249"
            >
              <path
                id="Detail_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.10781 168.983C-28.3544 60.0452 66.3247 6.53723 137.533 19.4628C208.695 32.6477 196.84 67.1286 312.601 67.2013C428.14 67.1286 441.042 195.069 375.662 239.54C310.615 284.426 44.4797 277.77 8.10781 168.983Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                id="Detail_3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M175.471 110.436C177.855 110.436 180.087 109.835 182.166 108.633C184.245 107.43 185.896 105.822 187.119 103.808C188.342 101.794 188.953 99.6151 188.953 97.2705C188.953 94.926 188.342 92.7317 187.119 90.6877C185.896 88.6438 184.245 87.0206 182.166 85.8183C180.087 84.6159 177.855 84.0148 175.471 84.0148C173.086 84.0148 170.87 84.6159 168.821 85.8183C166.773 87.0206 165.137 88.6438 163.914 90.6877C162.691 92.7317 162.08 94.926 162.08 97.2705C162.08 99.6151 162.691 101.794 163.914 103.808C165.137 105.822 166.773 107.43 168.821 108.633C170.87 109.835 173.086 110.436 175.471 110.436ZM210.241 101.74L219.912 108.979C220.357 109.334 220.616 109.795 220.69 110.363C220.765 110.931 220.653 111.463 220.357 111.96L211.019 127.29C210.723 127.786 210.334 128.106 209.852 128.248C209.37 128.39 208.833 128.354 208.24 128.141L196.79 123.777C193.826 125.835 191.195 127.29 188.898 128.141L187.23 139.745C187.082 140.313 186.804 140.774 186.397 141.129C185.989 141.484 185.526 141.661 185.007 141.661H166.332C165.813 141.661 165.35 141.484 164.942 141.129C164.534 140.774 164.294 140.313 164.219 139.745L162.441 128.141C159.328 126.935 156.734 125.48 154.659 123.777L143.098 128.141C141.913 128.638 140.986 128.354 140.319 127.29L130.982 111.96C130.685 111.463 130.574 110.931 130.648 110.363C130.722 109.795 130.982 109.334 131.426 108.979L141.209 101.74C141.06 100.747 140.986 99.2918 140.986 97.3756C140.986 95.4593 141.06 94.0045 141.209 93.0109L131.426 85.7719C130.982 85.417 130.722 84.9557 130.648 84.3879C130.574 83.8202 130.685 83.2879 130.982 82.7911L140.319 67.4614C140.986 66.3968 141.913 66.113 143.098 66.6098L154.659 70.9745C157.327 69.0582 159.921 67.6034 162.441 66.6098L164.219 55.0061C164.294 54.4383 164.534 53.977 164.942 53.6221C165.35 53.2673 165.813 53.0898 166.332 53.0898H185.007C185.526 53.0898 185.989 53.2673 186.397 53.6221C186.804 53.977 187.082 54.4383 187.23 55.0061L188.898 66.6098C191.788 67.6743 194.419 69.1292 196.79 70.9745L208.24 66.6098C208.833 66.3968 209.37 66.3614 209.852 66.5033C210.334 66.6452 210.723 66.9646 211.019 67.4614L220.357 82.7911C220.653 83.2879 220.765 83.8202 220.69 84.3879C220.616 84.9557 220.357 85.417 219.912 85.7719L210.241 93.0109C210.389 94.0045 210.463 95.4593 210.463 97.3756C210.463 99.2918 210.389 100.747 210.241 101.74Z"
                fill="#E7E8EA"
                fillOpacity="0.1"
              />
              <path
                id="Detail_4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M88.6952 87.7508C91.7355 84.5001 94.088 80.78 95.753 76.5903C97.4179 72.4005 98.2503 67.9942 98.2503 63.371C98.2503 58.4589 97.2912 53.7636 95.3729 49.285C93.4546 44.8063 90.7763 40.8875 87.3379 37.5285C83.8995 34.1695 79.9725 31.6232 75.5568 29.8895V31.8399C75.5568 34.296 74.652 36.3908 72.8423 38.1245C71.0326 39.8581 68.8971 40.725 66.436 40.725H57.5323V49.8267C57.5323 51.0548 57.0799 52.1022 56.175 52.969C55.2702 53.8359 54.1663 54.2693 52.8633 54.2693H43.9596V58.8635H74.6894C75.1864 58.8635 75.5894 59.2664 75.5894 59.7635V81.3579H80.0086C81.9631 81.3579 83.7366 81.9538 85.3291 83.1457C86.9217 84.3376 88.0437 85.8726 88.6952 87.7508ZM56.4882 98.4879V89.8651C54.0652 89.8651 51.9628 88.9669 50.1811 87.1705C48.3995 85.3741 47.5087 83.2543 47.5087 80.8112V76.392L26.2356 54.9429C25.523 57.6734 25.1666 60.3321 25.1666 62.9189C25.1666 68.883 26.592 74.5237 29.4426 79.8411C32.1508 84.8711 35.8922 89.0567 40.6671 92.3981C45.442 95.7394 50.7156 97.7693 56.4882 98.4879ZM61.5593 17.6611C69.7885 17.6611 77.4039 19.7181 84.4059 23.832C91.1913 27.7294 96.5329 33.0702 100.431 39.8545C104.545 46.8554 106.603 54.4696 106.603 62.6975C106.603 70.9253 104.545 78.5395 100.431 85.5404C96.5329 92.3247 91.1913 97.6655 84.4059 101.563C77.4039 105.677 69.7885 107.734 61.5593 107.734C53.3302 107.734 45.7148 105.677 38.7128 101.563C31.9274 97.5934 26.5857 92.2165 22.6877 85.4321C18.5732 78.4313 16.5159 70.8531 16.5159 62.6975C16.5159 54.5418 18.5732 46.9636 22.6877 39.9628C26.6579 33.1784 32.0357 27.8015 38.8211 23.832C45.823 19.7181 53.4024 17.6611 61.5593 17.6611Z"
                fill="#E7E8EA"
                fillOpacity="0.1"
              />
              <path
                id="Detail_5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M318.107 190.15C318.107 190.067 318.174 190 318.257 190H330.969C331.052 190 331.119 190.067 331.119 190.15V198.107H368.155V190.15C368.155 190.067 368.222 190 368.305 190H381.017C381.1 190 381.167 190.067 381.167 190.15V198.107H390.677C393.164 198.107 395.181 199.921 395.181 202.16V267.012C395.181 269.251 393.164 271.065 390.677 271.065H309.598C307.111 271.065 305.094 269.251 305.094 267.012V202.16C305.094 199.921 307.111 198.107 309.598 198.107H318.107V190.15ZM316.105 208.075C316.105 208.041 316.132 208.015 316.165 208.015H384.778C384.811 208.015 384.838 208.041 384.838 208.075V261.698C384.838 261.731 384.811 261.758 384.778 261.758H316.165C316.132 261.758 316.105 261.731 316.105 261.698V208.075ZM328.116 217.923H337.125V226.029H328.116V217.923ZM354.141 217.923H345.133V226.029H354.141V217.923ZM364.151 217.923H373.16V226.029H364.151V217.923ZM337.125 234.136H328.116V242.242H337.125V234.136ZM345.133 234.136H354.141V242.242H345.133V234.136ZM373.16 234.136H364.151V242.242H373.16V234.136Z"
                fill="#E7E8EA"
                fillOpacity="0.1"
              />
              <path
                id="Detail_6"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M330.919 51.5889C339.148 51.5889 346.764 53.6458 353.766 57.7597C360.551 61.6571 365.893 66.9979 369.791 73.7822C373.905 80.7831 375.962 88.3974 375.962 96.6252C375.962 104.853 373.905 112.467 369.791 119.468C365.893 126.252 360.551 131.593 353.766 135.491C346.764 139.605 339.148 141.662 330.919 141.662C322.69 141.662 315.074 139.605 308.072 135.491C301.287 131.521 295.945 126.144 292.047 119.36C287.933 112.359 285.876 104.781 285.876 96.6252C285.876 88.4695 287.933 80.8914 292.047 73.8905C296.018 67.1062 301.395 61.7293 308.181 57.7597C315.183 53.6458 322.762 51.5889 330.919 51.5889ZM334.43 96.8792L351.345 106.842C353.468 108.093 354.176 110.811 352.929 112.926C351.698 115.015 348.993 115.718 346.888 114.496C346.857 114.478 325.314 101.496 325.314 101.496V77.2805C325.314 74.7828 327.355 72.758 329.872 72.758C332.389 72.758 334.43 74.7828 334.43 77.2805V96.8792Z"
                fill="#E7E8EA"
                fillOpacity="0.1"
              />
              <path
                id="Detail_7"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M259.062 199.756C261.137 199.756 262.893 199.038 264.329 197.601C265.766 196.165 266.484 194.37 266.484 192.215C266.484 190.061 265.766 188.285 264.329 186.889C262.893 185.493 261.137 184.795 259.062 184.795C256.987 184.795 255.211 185.513 253.735 186.949C252.259 188.385 251.52 190.141 251.52 192.215C251.52 194.29 252.239 196.065 253.675 197.541C255.112 199.018 256.907 199.756 259.062 199.756ZM244.098 180.215C246.173 180.215 247.929 179.496 249.366 178.06C250.802 176.624 251.52 174.829 251.52 172.674C251.52 170.52 250.802 168.744 249.366 167.348C247.929 165.952 246.173 165.253 244.098 165.253C242.024 165.253 240.248 165.971 238.771 167.408C237.295 168.844 236.557 170.599 236.557 172.674C236.557 174.749 237.275 176.524 238.712 178C240.148 179.476 241.944 180.215 244.098 180.215ZM219.668 180.215C221.743 180.215 223.499 179.496 224.935 178.06C226.372 176.624 227.09 174.829 227.09 172.674C227.09 170.52 226.372 168.744 224.935 167.348C223.499 165.952 221.743 165.253 219.668 165.253C217.593 165.253 215.818 165.971 214.341 167.408C212.865 168.844 212.126 170.599 212.126 172.674C212.126 174.749 212.845 176.524 214.281 178C215.718 179.476 217.513 180.215 219.668 180.215ZM204.705 199.756C206.78 199.756 208.535 199.038 209.972 197.601C211.408 196.165 212.126 194.37 212.126 192.215C212.126 190.061 211.408 188.285 209.972 186.889C208.535 185.493 206.78 184.795 204.705 184.795C202.63 184.795 200.854 185.513 199.378 186.949C197.901 188.385 197.163 190.141 197.163 192.215C197.163 194.29 197.881 196.065 199.318 197.541C200.754 199.018 202.55 199.756 204.705 199.756ZM231.823 154.872C239.991 154.872 247.559 156.714 254.525 160.397C261.332 163.919 266.737 168.723 270.741 174.808C274.825 180.973 276.867 187.699 276.867 194.984C276.867 199.468 275.746 203.631 273.504 207.474C271.261 211.318 268.219 214.34 264.375 216.542C260.531 218.744 256.327 219.844 251.763 219.844H243.114C241.032 219.844 239.251 220.565 237.769 222.006C236.288 223.447 235.547 225.209 235.547 227.29C235.547 229.132 236.188 230.773 237.469 232.214C238.029 232.855 238.49 233.656 238.85 234.616C239.211 235.577 239.391 236.498 239.391 237.379C239.391 239.54 238.65 241.342 237.169 242.783C235.687 244.224 233.905 244.945 231.823 244.945C223.656 244.945 216.088 242.903 209.122 238.82C202.315 234.817 196.91 229.412 192.906 222.607C188.822 215.641 186.78 208.075 186.78 199.908C186.78 191.742 188.822 184.176 192.906 177.21C196.91 170.405 202.315 165 209.122 160.997C216.088 156.914 223.656 154.872 231.823 154.872Z"
                fill="#E7E8EA"
                fillOpacity="0.1"
              />
              <path
                id="Detail_8"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M109.906 190C109.906 165.14 89.7265 144.964 64.8625 144.964C39.9986 144.964 19.8191 165.14 19.8191 190C19.8191 214.86 39.9986 235.037 64.8625 235.037C89.7265 235.037 109.906 214.86 109.906 190ZM79.5867 175.903L58.7368 196.76C58.7368 196.76 50.862 188.929 50.8315 188.9C48.9477 187.133 45.9465 187.184 44.1282 189.015L43.9525 189.192C42.168 190.989 42.1805 193.841 43.9808 195.623L58.7368 210.267L86.5888 182.586C88.4001 180.793 88.4001 177.92 86.5888 176.127C86.5888 176.127 86.3152 175.857 86.2932 175.836C84.4222 174.054 81.4196 174.084 79.5867 175.903Z"
                fill="#E7E8EA"
                fillOpacity="0.1"
              />
            </g>
          </g>
          <g id="girl">
            <path
              id="Sh"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M145.322 307.449C149.786 300.523 189.922 296.49 217.528 296.49C245.188 296.49 264.361 303.674 239.487 308.42C214.759 313.167 141.218 314.356 145.322 307.449Z"
              fill="#E7E8EA"
              fillOpacity="0.1"
            />
            <g id="Ler L">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M166.694 265.068C163.73 269.931 159.539 285.035 159.539 288.95C159.539 292.865 172.125 288.548 174.525 278.44C176.924 268.333 179.315 271.891 179.315 266.641C179.315 261.391 169.658 260.205 166.694 265.068Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M166.694 265.068C163.73 269.931 159.539 285.035 159.539 288.95C159.539 292.865 172.125 288.548 174.525 278.44C176.924 268.333 179.315 271.891 179.315 266.641C179.315 261.391 169.658 260.205 166.694 265.068Z"
                fill="url(#paint0_linear)"
              />
            </g>
            <g id="Leg R">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M218.571 265.083C216.298 270.73 219.165 283.796 224.614 289.789C230.064 295.781 235.544 283.929 233.546 281.279C231.547 278.629 226.818 273.435 226.818 266.327C226.818 259.219 220.844 259.436 218.571 265.083Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M218.571 265.083C216.298 270.73 219.165 283.796 224.614 289.789C230.064 295.781 235.544 283.929 233.546 281.279C231.547 278.629 226.818 273.435 226.818 266.327C226.818 259.219 220.844 259.436 218.571 265.083Z"
                fill="url(#paint1_linear)"
              />
            </g>
            <g id="Hand R">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M207.719 103.156C213.668 110.388 208.406 131.44 212.393 136.576C216.712 141.616 225.796 147.463 230.011 157.778C234.116 168.217 205.679 146.84 203.045 143.045C200.073 138.937 201.993 96.092 207.719 103.156Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M207.719 103.156C213.668 110.388 208.406 131.44 212.393 136.576C216.712 141.616 225.796 147.463 230.011 157.778C234.116 168.217 205.679 146.84 203.045 143.045C200.073 138.937 201.993 96.092 207.719 103.156Z"
                fill="url(#paint2_linear)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M207.719 103.156C213.668 110.388 208.406 131.44 212.393 136.576C216.712 141.616 225.796 147.463 230.011 157.778C234.116 168.217 205.679 146.84 203.045 143.045C200.073 138.937 201.993 96.092 207.719 103.156Z"
                fill="url(#paint3_linear)"
              />
            </g>
            <g id="Legs">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M172.483 144.123C163.183 161.045 158.82 184.728 158.82 203.544C158.82 222.36 164.493 265.23 164.493 265.23C164.493 265.23 165.726 268.819 171.914 268.819C178.102 268.819 179.256 265.23 179.256 265.23C179.256 265.23 182.301 231.176 182.301 220.56C182.301 209.944 188.158 172.868 191.115 172.868C194.071 172.868 200.908 202.934 204.794 220.56C208.68 238.187 216.724 265.23 216.724 265.23C216.724 265.23 217.535 268.819 223.532 268.819C229.529 268.819 230.73 265.23 230.73 265.23C230.73 265.23 228.06 198.269 223.532 178.948C219.489 161.692 209.517 144.123 209.517 144.123C209.517 144.123 181.783 127.2 172.483 144.123Z"
                fill="#88A0FC"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M172.483 144.123C163.183 161.045 158.82 184.728 158.82 203.544C158.82 222.36 164.493 265.23 164.493 265.23C164.493 265.23 165.726 268.819 171.914 268.819C178.102 268.819 179.256 265.23 179.256 265.23C179.256 265.23 182.301 231.176 182.301 220.56C182.301 209.944 188.158 172.868 191.115 172.868C194.071 172.868 200.908 202.934 204.794 220.56C208.68 238.187 216.724 265.23 216.724 265.23C216.724 265.23 217.535 268.819 223.532 268.819C229.529 268.819 230.73 265.23 230.73 265.23C230.73 265.23 228.06 198.269 223.532 178.948C219.489 161.692 209.517 144.123 209.517 144.123C209.517 144.123 181.783 127.2 172.483 144.123Z"
                fill="#6785FB"
              />
            </g>
            <g id="Hair">
              <g id="Hair_2">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M177.143 109.868C159.157 107.106 132.751 84.545 147.451 55.3513C162.152 26.1576 185.732 43.1266 199.32 18.1161C212.907 -6.89434 244.975 -3.73678 260.402 13.8009C275.83 31.3386 275.83 58.6053 250.932 84.111C226.033 109.617 195.129 112.63 177.143 109.868Z"
                  fill="#88A0FC"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M177.143 109.868C159.157 107.106 132.751 84.545 147.451 55.3513C162.152 26.1576 185.732 43.1266 199.32 18.1161C212.907 -6.89434 244.975 -3.73678 260.402 13.8009C275.83 31.3386 275.83 58.6053 250.932 84.111C226.033 109.617 195.129 112.63 177.143 109.868Z"
                  fill="#6785FB"
                />
              </g>
              <path
                id="Sh_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M267.58 59.2441C264.413 67.4589 258.97 75.8767 250.932 84.111C234.954 100.478 216.504 107.583 200.581 109.844C183.827 105.734 171.464 96.252 173.757 78.4135C179.328 35.0907 240.481 103.547 267.58 59.2441V59.2441Z"
                fill="url(#paint4_linear)"
              />
              <mask
                id="mask1"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="173"
                y="59"
                width="95"
                height="51"
              >
                <path
                  id="Sh_3"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M267.58 59.2441C264.413 67.4589 258.97 75.8767 250.932 84.111C234.954 100.478 216.504 107.583 200.581 109.844C183.827 105.734 171.464 96.252 173.757 78.4135C179.328 35.0907 240.481 103.547 267.58 59.2441Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1)"></g>
            </g>
            <g id="Body">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M172.483 144.123C176.272 136.591 176.821 137.912 173.921 129.749C171.65 121.377 168.165 120.761 166.371 110.703C165.162 100.842 174.646 90.6752 186.865 96.6881C198.846 102.741 197.529 98.8186 204.843 102.078C212.19 105.621 210.923 113.356 207.719 121.124C204.323 128.905 204.211 136.44 209.517 144.123C214.303 151.863 168.906 151.712 172.483 144.123Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M172.483 144.123C176.272 136.591 176.821 137.912 173.921 129.749C171.65 121.377 168.165 120.761 166.371 110.703C165.162 100.842 174.646 90.6752 186.865 96.6881C198.846 102.741 197.529 98.8186 204.843 102.078C212.19 105.621 210.923 113.356 207.719 121.124C204.323 128.905 204.211 136.44 209.517 144.123C214.303 151.863 168.906 151.712 172.483 144.123Z"
                fill="url(#paint5_linear)"
              />
            </g>
            <g id="Nack">
              <rect x="186.146" y="85.9072" width="10.427" height="19.0459" rx="5.21348" fill="#FFC62C" />
              <rect x="186.146" y="85.9072" width="10.427" height="19.0459" rx="5.21348" fill="url(#paint6_linear)" />
            </g>
            <g id="Face">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M171 82.3268C169.684 82.2379 168.303 80.9499 168.303 77.5527C168.303 73.1422 165.019 71.7557 165.019 68.8095C165.019 65.8632 168.137 64.6543 169.746 66.6089C171.178 63.3627 173.68 64.5123 184.476 61.6238C195.273 58.7353 199.496 50.7446 208.434 54.5915C208.493 56.2893 208.434 61.7621 208.434 63.6384C208.434 65.3326 210.595 67.5731 210.595 75.4926C210.595 83.3386 202.293 94.1718 192.947 94.1718C186.176 94.1718 175.209 90.2747 171 82.3268Z"
                fill="#FFC62C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M171 82.3268C169.684 82.2379 168.303 80.9499 168.303 77.5527C168.303 73.1422 165.019 71.7557 165.019 68.8095C165.019 65.8632 168.137 64.6543 169.746 66.6089C171.178 63.3627 173.68 64.5123 184.476 61.6238C195.273 58.7353 199.496 50.7446 208.434 54.5915C208.493 56.2893 208.434 61.7621 208.434 63.6384C208.434 65.3326 210.595 67.5731 210.595 75.4926C210.595 83.3386 202.293 94.1718 192.947 94.1718C186.176 94.1718 175.209 90.2747 171 82.3268Z"
                fill="url(#paint7_linear)"
              />
            </g>
            <path
              id="Sh_4"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M196.645 64.7255C190.215 68.1056 175.091 70.2263 169.696 62.6695C171.467 61.4075 175.189 64.1084 184.476 61.6238C195.273 58.7353 199.496 50.7446 208.434 54.5915C208.481 55.9549 208.453 59.7525 208.44 62.1673C206.254 62.1796 203.075 61.3453 196.645 64.7255Z"
              fill="url(#paint8_linear)"
            />
            <g id="Hand L">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M171 118.937C160.546 113.862 169.536 81.1318 171 68.7495C172.463 56.3671 174.579 36.2708 174.579 32.1342C174.579 27.9976 182.91 27.3115 182.91 32.1342C182.91 36.9569 181.453 59.3798 181.453 68.7495C181.453 78.1191 181.453 124.012 171 118.937Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M171 118.937C160.546 113.862 169.536 81.1318 171 68.7495C172.463 56.3671 174.579 36.2708 174.579 32.1342C174.579 27.9976 182.91 27.3115 182.91 32.1342C182.91 36.9569 181.453 59.3798 181.453 68.7495C181.453 78.1191 181.453 124.012 171 118.937Z"
                fill="url(#paint9_linear)"
              />
            </g>
            <g id="Hand L_2">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M174.64 31.644C174.64 27.2782 171.918 24.1886 165.611 25.0453C159.304 25.902 155.808 27.2275 156.843 25.0453C157.35 23.9749 160.256 21.9446 166.337 20.9833C168.521 20.6381 175.7 21.4249 175.7 21.4249C175.7 21.4249 179.707 19.9918 182.562 20.9833C185.418 21.9748 189.439 18.6734 191.31 20.9833C193.18 23.2932 182.203 24.0023 182.562 26.4246C182.922 28.847 182.922 30.9595 182.922 32.7667C182.922 34.5739 174.64 36.0097 174.64 31.644Z"
                fill="#FFC62C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M174.64 31.644C174.64 27.2782 171.918 24.1886 165.611 25.0453C159.304 25.902 155.808 27.2275 156.843 25.0453C157.35 23.9749 160.256 21.9446 166.337 20.9833C168.521 20.6381 175.7 21.4249 175.7 21.4249C175.7 21.4249 179.707 19.9918 182.562 20.9833C185.418 21.9748 189.439 18.6734 191.31 20.9833C193.18 23.2932 182.203 24.0023 182.562 26.4246C182.922 28.847 182.922 30.9595 182.922 32.7667C182.922 34.5739 174.64 36.0097 174.64 31.644Z"
                fill="url(#paint10_linear)"
              />
            </g>
            <g id="Hand R_2">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M223.853 158.584C228.724 162.528 231.913 162.491 230.316 167.939C228.719 173.386 225.291 173.615 226.804 175.436C228.317 177.257 231.942 170.503 235.897 169.605C239.852 168.708 251.613 170.305 253.293 167.939C254.974 165.572 251.936 164.791 244.059 163.881C236.182 162.971 228.466 153.705 226.106 150.908C224.47 148.97 220.748 156.07 223.853 158.584Z"
                fill="#FFC62C"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M223.853 158.584C228.724 162.528 231.913 162.491 230.316 167.939C228.719 173.386 225.291 173.615 226.804 175.436C228.317 177.257 231.942 170.503 235.897 169.605C239.852 168.708 251.613 170.305 253.293 167.939C254.974 165.572 251.936 164.791 244.059 163.881C236.182 162.971 228.466 153.705 226.106 150.908C224.47 148.97 220.748 156.07 223.853 158.584Z"
                fill="url(#paint11_linear)"
              />
            </g>
            <path
              id="Sh_5"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M186.146 93.1523C188.591 93.8336 190.951 94.1722 192.947 94.1722C194.179 94.1722 195.394 93.9839 196.573 93.6389V97.2324C195.394 97.5774 194.179 97.7658 192.947 97.7658C190.951 97.7658 188.591 97.4271 186.146 96.7459V93.1523L186.146 93.1523Z"
              fill="url(#paint12_linear)"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="159.539"
            y1="261.992"
            x2="159.539"
            y2="290.381"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A7A7EE" stopOpacity="0.01" />
            <stop offset="1" stopColor="#4C55A0" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="217.786"
            y1="260.914"
            x2="217.786"
            y2="291.459"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A7A7EE" stopOpacity="0.01" />
            <stop offset="1" stopColor="#4C55A0" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="201.607"
            y1="102.438"
            x2="201.607"
            y2="160.653"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A7A7EE" stopOpacity="0.01" />
            <stop offset="1" stopColor="#4C55A0" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="204.049"
            y1="154.605"
            x2="229.723"
            y2="155.306"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D5D5D5" stopOpacity="0.6" />
            <stop offset="1" stopColor="#A7A7EE" stopOpacity="0.01" />
          </linearGradient>
          <linearGradient
            id="paint4_linear"
            x1="126.435"
            y1="84.544"
            x2="168.647"
            y2="163.044"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0.3" />
            <stop offset="1" stopColor="#1F1845" stopOpacity="0.01" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="166.267"
            y1="94.8877"
            x2="166.267"
            y2="149.871"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A7A7EE" stopOpacity="0.01" />
            <stop offset="1" stopColor="#4C55A0" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint6_linear"
            x1="186.146"
            y1="85.9072"
            x2="186.146"
            y2="104.953"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC62C" stopOpacity="0.01" />
            <stop offset="1" stopColor="#FF6663" stopOpacity="0.1" />
          </linearGradient>
          <linearGradient
            id="paint7_linear"
            x1="165.019"
            y1="53.5645"
            x2="165.019"
            y2="94.1718"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC62C" stopOpacity="0.01" />
            <stop offset="1" stopColor="#FF6663" stopOpacity="0.1" />
          </linearGradient>
          <linearGradient
            id="paint8_linear"
            x1="189.078"
            y1="46.4472"
            x2="179.866"
            y2="71.5334"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0.2" />
            <stop offset="1" stopColor="#FFC42C" stopOpacity="0.01" />
          </linearGradient>
          <linearGradient
            id="paint9_linear"
            x1="166.011"
            y1="28.7695"
            x2="166.011"
            y2="119.328"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F4F4FF" stopOpacity="0.01" />
            <stop offset="1" stopColor="#4C55A0" stopOpacity="0.2" />
          </linearGradient>
          <linearGradient
            id="paint10_linear"
            x1="156.663"
            y1="20.1445"
            x2="156.663"
            y2="34.5217"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC62C" stopOpacity="0.01" />
            <stop offset="1" stopColor="#FF6663" stopOpacity="0.1" />
          </linearGradient>
          <linearGradient
            id="paint11_linear"
            x1="222.655"
            y1="150.577"
            x2="222.655"
            y2="175.746"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC62C" stopOpacity="0.01" />
            <stop offset="1" stopColor="#FF6663" stopOpacity="0.1" />
          </linearGradient>
          <linearGradient
            id="paint12_linear"
            x1="202.285"
            y1="95.9006"
            x2="199.069"
            y2="87.9342"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0.2" />
            <stop offset="1" stopColor="#FFC42C" stopOpacity="0.01" />
          </linearGradient>
        </defs>
      </svg>
    )
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 415 313" style={{ width: '100%' }}>
      <defs>
        <path
          id="a"
          d="M8.108 151.322C-28.354 42.384 66.325-11.124 137.533 1.802 208.695 14.985 196.84 49.466 312.6 49.54c115.54-.073 128.441 127.867 63.061 172.339-65.047 44.886-331.182 38.23-367.554-70.557z"
        />
        <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#A7A7EE" stopOpacity="0" />
          <stop offset="100%" stopColor="#4C55A0" stopOpacity=".2" />
        </linearGradient>
        <path
          id="c"
          d="M23.694 265.407c-2.964 4.863-7.155 19.967-7.155 23.882 0 3.915 12.586-.403 14.986-10.51 2.4-10.108 4.79-6.55 4.79-11.8 0-5.25-9.657-6.435-12.621-1.572z"
        />
        <path
          id="e"
          d="M75.57 265.422c-2.272 5.647.595 18.713 6.044 24.705 5.45 5.993 10.93-5.86 8.932-8.51-1.999-2.649-6.728-7.843-6.728-14.951 0-7.109-5.974-6.892-8.247-1.244z"
        />
        <linearGradient id="g" x1="10.947%" y1="45.085%" y2="50%">
          <stop offset="0%" stopColor="#464D89" stopOpacity=".6" />
          <stop offset="100%" stopColor="#A7A7EE" stopOpacity="0" />
        </linearGradient>
        <path
          id="f"
          d="M64.72 103.495c5.948 7.232.686 28.284 4.673 33.42 4.319 5.04 13.403 10.887 17.618 21.202 4.105 10.438-24.332-10.939-26.966-14.734-2.972-4.108-1.052-46.952 4.674-39.888z"
        />
        <linearGradient id="i" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#403F9F" stopOpacity="0" />
          <stop offset="100%" stopOpacity=".2" />
        </linearGradient>
        <path
          id="h"
          d="M29.483 144.462c-9.3 16.922-13.663 40.605-13.663 59.42 0 12.545 1.891 33.107 5.673 61.687.822 2.393 3.296 3.59 7.421 3.59 4.126 0 6.573-1.197 7.342-3.59 2.03-22.702 3.045-37.592 3.045-44.67 0-10.616 5.857-47.692 8.814-47.692 2.956 0 9.793 30.066 13.68 47.692 2.59 11.751 6.567 26.641 11.929 44.67.54 2.393 2.81 3.59 6.808 3.59 3.998 0 6.397-1.197 7.198-3.59-1.78-44.64-4.18-73.401-7.198-86.282-4.043-17.256-14.015-34.825-14.015-34.825s-27.734-16.923-37.034 0z"
        />
        <path
          id="j"
          d="M34.143 110.207C16.157 107.445-10.249 84.884 4.451 55.69 19.152 26.496 42.732 43.465 56.32 18.455c13.587-25.01 45.655-21.853 61.082-4.315 15.428 17.537 15.428 44.804-9.47 70.31-24.899 25.505-55.803 28.52-73.789 25.757z"
        />
        <linearGradient id="k" x1="0%" y1="0%" y2="100%">
          <stop offset="0%" stopOpacity=".3" />
          <stop offset="100%" stopColor="#1F1845" stopOpacity="0" />
        </linearGradient>
        <path
          id="l"
          d="M124.58 59.583c-3.167 8.215-8.61 16.632-16.648 24.867-15.978 16.367-34.428 23.472-50.351 25.733-16.754-4.11-29.117-13.592-26.824-31.43 5.57-43.324 66.724 25.132 93.823-19.17z"
        />
        <path
          id="m"
          d="M29.483 144.462c3.79-7.533 4.338-6.212 1.438-14.375-2.27-8.372-5.756-8.988-7.55-19.046-1.21-9.86 8.275-20.028 20.494-14.015 11.981 6.053 10.664 2.13 17.978 5.39 7.347 3.543 6.08 11.279 2.876 19.047-3.396 7.78-3.508 15.316 1.798 22.999 4.786 7.739-40.611 7.589-37.034 0z"
        />
        <linearGradient id="o" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FFC62C" stopOpacity="0" />
          <stop offset="100%" stopColor="#FF6663" stopOpacity=".1" />
        </linearGradient>
        <rect id="n" width="10.427" height="19.046" x="43.146" y="86.246" rx="5.213" />
        <path
          id="p"
          d="M28 82.666c-1.316-.089-2.697-1.377-2.697-4.774 0-4.41-3.284-5.797-3.284-8.743 0-2.947 3.118-4.156 4.727-2.201 1.432-3.246 3.934-2.097 14.73-4.985 10.797-2.889 15.02-10.88 23.958-7.032.059 1.697 0 7.17 0 9.047 0 1.694 2.162 3.934 2.162 11.854 0 7.846-8.303 18.679-17.649 18.679-6.77 0-17.738-3.897-21.947-11.845z"
        />
        <linearGradient id="q" x1="100%" x2="0%" y1="0%" y2="100%">
          <stop offset="0%" stopOpacity=".2" />
          <stop offset="100%" stopColor="#FFC42C" stopOpacity="0" />
        </linearGradient>
        <path
          id="r"
          d="M28 119.275c-10.454-5.075-1.464-37.805 0-50.187 1.463-12.383 3.579-32.479 3.579-36.615 0-4.137 8.331-4.823 8.331 0 0 4.822-1.457 27.245-1.457 36.615 0 9.37 0 55.263-10.453 50.187z"
        />
        <path
          id="s"
          d="M31.64 31.983c0-4.366-2.722-7.456-9.03-6.599-6.306.857-9.802 2.182-8.767 0 .507-1.07 3.413-3.1 9.494-4.062 1.456-.23 4.577-.083 9.363.442 2.671-.956 4.958-1.103 6.862-.442 2.856.992 6.877-2.31 8.748 0 1.87 2.31-9.107 3.02-8.748 5.441.36 2.423.36 4.535.36 6.343 0 1.807-8.282 3.243-8.282-1.123z"
        />
        <path
          id="t"
          d="M80.853 158.923c4.87 3.944 8.06 3.907 6.463 9.355-1.597 5.447-5.025 5.676-3.512 7.497 1.513 1.82 5.138-4.933 9.093-5.83 3.955-.898 15.716.7 17.396-1.667 1.68-2.367-1.357-3.147-9.234-4.058-7.877-.91-15.593-10.176-17.953-12.973-1.636-1.938-5.358 5.162-2.253 7.676z"
        />
        <linearGradient id="u" x1="100%" x2="0%" y1="109.57%" y2="0%">
          <stop offset="0%" stopOpacity=".2" />
          <stop offset="100%" stopColor="#FFC42C" stopOpacity="0" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 18)">
          <mask id="b" fill="#fff">
            <use href="#a" />
          </mask>
          <use fill="#F2F2F4" href="#a" />
          <path
            fill="#E7E8EA"
            d="M175.47 92.775c2.385 0 4.617-.601 6.696-1.804 2.08-1.202 3.73-2.81 4.953-4.824a12.37 12.37 0 0 0 1.834-6.538c0-2.344-.611-4.539-1.834-6.583a13.622 13.622 0 0 0-4.953-4.869 13.153 13.153 0 0 0-6.695-1.803c-2.385 0-4.601.6-6.65 1.803a13.734 13.734 0 0 0-4.907 4.87c-1.223 2.043-1.834 4.238-1.834 6.582 0 2.345.611 4.524 1.834 6.538a13.854 13.854 0 0 0 4.907 4.824 12.908 12.908 0 0 0 6.65 1.804zm34.771-8.696l9.671 7.239c.445.355.704.816.779 1.384.074.568-.038 1.1-.334 1.597l-9.338 15.33c-.296.496-.685.816-1.167.958-.482.141-1.019.106-1.612-.107l-11.45-4.365c-2.964 2.059-5.595 3.513-7.892 4.365l-1.668 11.604c-.148.568-.426 1.029-.833 1.384a2.058 2.058 0 0 1-1.39.532h-18.675c-.52 0-.982-.177-1.39-.532-.408-.355-.648-.816-.723-1.384l-1.778-11.604c-3.113-1.206-5.707-2.661-7.782-4.365l-11.56 4.365c-1.186.497-2.113.213-2.78-.852l-9.337-15.33a2.422 2.422 0 0 1-.334-1.596c.074-.568.334-1.03.778-1.384l9.783-7.239c-.149-.994-.223-2.448-.223-4.365 0-1.916.074-3.37.223-4.364l-9.783-7.24a2.046 2.046 0 0 1-.778-1.383 2.42 2.42 0 0 1 .334-1.597l9.337-15.33c.667-1.064 1.594-1.348 2.78-.852l11.56 4.365c2.668-1.916 5.262-3.37 7.782-4.365l1.778-11.603c.075-.568.315-1.03.723-1.384.408-.355.87-.532 1.39-.532h18.675c.519 0 .982.177 1.39.532.407.355.685.816.833 1.384l1.668 11.603a29.198 29.198 0 0 1 7.892 4.365l11.45-4.365c.593-.212 1.13-.248 1.612-.106.482.142.87.461 1.167.958l9.338 15.33c.296.497.408 1.029.334 1.597a2.046 2.046 0 0 1-.779 1.384l-9.67 7.239c.147.993.221 2.448.221 4.364 0 1.917-.074 3.371-.222 4.365zM88.695 70.09c3.04-3.251 5.393-6.971 7.058-11.16 1.665-4.19 2.497-8.597 2.497-13.22 0-4.912-.959-9.607-2.877-14.086-1.918-4.479-4.597-8.398-8.035-11.757-3.439-3.359-7.366-5.905-11.781-7.639v1.95c0 2.457-.905 4.552-2.715 6.285-1.81 1.734-3.945 2.6-6.406 2.6h-8.904v9.103c0 1.228-.452 2.275-1.357 3.142s-2.009 1.3-3.312 1.3H43.96v4.594h30.73a.9.9 0 0 1 .9.9v21.595h4.419c1.954 0 3.728.596 5.32 1.788a9.53 9.53 0 0 1 3.366 4.605zM56.488 80.827v-8.623c-2.423 0-4.525-.898-6.307-2.695-1.782-1.796-2.672-3.916-2.672-6.359v-4.42L26.236 37.283c-.713 2.73-1.07 5.389-1.07 7.976 0 5.964 1.426 11.605 4.277 16.922 2.708 5.03 6.45 9.216 11.224 12.557 4.775 3.341 10.049 5.371 15.821 6.09zM61.56 0c8.23 0 15.845 2.057 22.847 6.17 6.785 3.898 12.127 9.239 16.025 16.023 4.114 7.001 6.172 14.615 6.172 22.843s-2.058 15.842-6.172 22.843c-3.898 6.785-9.24 12.125-16.025 16.023-7.002 4.114-14.618 6.17-22.847 6.17-8.229 0-15.844-2.056-22.846-6.17-6.786-3.97-12.127-9.347-16.025-16.131-4.115-7-6.172-14.579-6.172-22.735 0-8.155 2.057-15.733 6.172-22.734 3.97-6.785 9.348-12.162 16.133-16.131C45.823 2.057 53.402 0 61.56 0z"
            mask="url(#b)"
          />
          <path
            fill="#E7E8EA"
            fillRule="nonzero"
            d="M316.105 190.414v53.623c0 .033.027.06.06.06h68.613a.06.06 0 0 0 .06-.06v-53.623a.06.06 0 0 0-.06-.06h-68.613a.06.06 0 0 0-.06.06zm65.062-9.968h9.51c2.487 0 4.504 1.814 4.504 4.053v64.852c0 2.239-2.017 4.053-4.504 4.053h-81.079c-2.487 0-4.504-1.814-4.504-4.053V184.5c0-2.239 2.017-4.053 4.504-4.053h8.509v-7.957a.15.15 0 0 1 .15-.15h12.712a.15.15 0 0 1 .15.15v7.957h37.036v-7.957a.15.15 0 0 1 .15-.15h12.712a.15.15 0 0 1 .15.15v7.957zm-53.05 19.816v8.106h9.008v-8.106h-9.009zm17.016 0v8.106h9.008v-8.106h-9.008zm19.018 0v8.106h9.009v-8.106h-9.009zm-36.035 16.213v8.106h9.009v-8.106h-9.009zm17.017 0v8.106h9.008v-8.106h-9.008zm19.018 0v8.106h9.009v-8.106h-9.009z"
            mask="url(#b)"
          />
          <path
            fill="#E7E8EA"
            d="M330.919 33.927c8.23 0 15.845 2.057 22.846 6.171 6.786 3.898 12.128 9.238 16.026 16.023 4.114 7 6.171 14.615 6.171 22.843s-2.057 15.842-6.171 22.843c-3.898 6.784-9.24 12.125-16.026 16.022-7.001 4.114-14.617 6.171-22.846 6.171-8.23 0-15.845-2.057-22.847-6.17-6.785-3.97-12.127-9.347-16.025-16.132-4.114-7-6.171-14.579-6.171-22.734 0-8.156 2.057-15.734 6.171-22.735 3.97-6.784 9.348-12.161 16.134-16.13 7.002-4.115 14.581-6.172 22.738-6.172zm3.51 45.29l16.916 9.964a4.438 4.438 0 0 1 1.584 6.084c-1.231 2.089-3.936 2.791-6.041 1.57l-21.574-13V59.618c0-2.498 2.041-4.522 4.558-4.522s4.558 2.024 4.558 4.522v19.599zm-75.367 102.877c2.075 0 3.83-.718 5.267-2.154 1.437-1.436 2.155-3.232 2.155-5.386 0-2.155-.718-3.93-2.155-5.326-1.436-1.397-3.192-2.095-5.267-2.095s-3.85.718-5.327 2.155c-1.476 1.436-2.215 3.191-2.215 5.266 0 2.074.719 3.85 2.155 5.326 1.437 1.476 3.232 2.214 5.387 2.214zm-14.964-19.54c2.075 0 3.831-.719 5.268-2.155 1.436-1.437 2.154-3.232 2.154-5.386 0-2.155-.718-3.93-2.154-5.327-1.437-1.396-3.193-2.094-5.268-2.094-2.074 0-3.85.718-5.327 2.154-1.476 1.437-2.214 3.192-2.214 5.267 0 2.074.718 3.85 2.155 5.326 1.436 1.476 3.232 2.214 5.386 2.214zm-24.43 0c2.075 0 3.83-.719 5.267-2.155 1.437-1.437 2.155-3.232 2.155-5.386 0-2.155-.718-3.93-2.155-5.327-1.436-1.396-3.192-2.094-5.267-2.094s-3.85.718-5.327 2.154c-1.476 1.437-2.215 3.192-2.215 5.267 0 2.074.719 3.85 2.155 5.326 1.437 1.476 3.232 2.214 5.387 2.214zm-14.963 19.54c2.075 0 3.83-.718 5.267-2.154 1.436-1.436 2.154-3.232 2.154-5.386 0-2.155-.718-3.93-2.154-5.326-1.437-1.397-3.192-2.095-5.267-2.095s-3.851.718-5.327 2.155c-1.477 1.436-2.215 3.191-2.215 5.266 0 2.074.718 3.85 2.155 5.326 1.436 1.476 3.232 2.214 5.387 2.214zm27.118-44.883c8.168 0 15.736 1.841 22.702 5.524 6.807 3.523 12.212 8.327 16.216 14.412 4.084 6.165 6.126 12.89 6.126 20.176 0 4.484-1.121 8.647-3.363 12.49-2.243 3.843-5.285 6.866-9.13 9.067-3.843 2.202-8.047 3.303-12.611 3.303h-8.649c-2.082 0-3.863.72-5.345 2.162-1.481 1.441-2.222 3.202-2.222 5.284 0 1.842.64 3.483 1.922 4.924.56.64 1.02 1.441 1.381 2.402.36.96.54 1.881.54 2.762 0 2.162-.74 3.963-2.221 5.405-1.482 1.44-3.264 2.161-5.346 2.161-8.167 0-15.735-2.041-22.701-6.125-6.807-4.003-12.212-9.407-16.216-16.213-4.084-6.965-6.126-14.531-6.126-22.698s2.042-15.733 6.126-22.698c4.004-6.806 9.409-12.21 16.216-16.213 6.966-4.084 14.534-6.125 22.701-6.125z"
            mask="url(#b)"
          />
          <path
            fill="#E7E8EA"
            fillRule="nonzero"
            d="M64.863 127.303c24.863 0 45.043 20.176 45.043 45.036 0 24.86-20.18 45.036-45.043 45.036-24.864 0-45.044-20.176-45.044-45.036 0-24.86 20.18-45.036 45.044-45.036zm-6.126 51.796c-5.25-5.221-7.885-7.841-7.906-7.86-1.883-1.767-4.884-1.716-6.703.115l-.175.177a4.517 4.517 0 0 0 .028 6.43l14.756 14.644 27.852-27.68a4.518 4.518 0 0 0 0-6.46c-.183-.18-.281-.277-.296-.29-1.87-1.782-4.873-1.752-6.706.067l-20.85 20.857z"
            mask="url(#b)"
          />
        </g>
        <path
          fill="#E7E8EA"
          d="M145.322 307.787c4.464-6.926 44.6-10.958 72.206-10.958 27.66 0 46.833 7.184 21.96 11.93-24.73 4.747-98.27 5.935-94.166-.972z"
        />
        <g transform="translate(143)">
          <use fill="#5678FB" href="#c" />
          <use fill="url(#d)" href="#c" />
        </g>
        <g transform="translate(143)">
          <use fill="#5678FB" href="#e" />
          <use fill="url(#d)" href="#e" />
        </g>
        <g transform="translate(143)">
          <use fill="#5678FB" href="#f" />
          <use fill="url(#d)" href="#f" />
          <use fill="url(#g)" href="#f" />
        </g>
        <g transform="translate(143)">
          <use fill="#233061" href="#h" />
          <use fill="url(#i)" href="#h" />
        </g>
        <g transform="translate(143)">
          <use fill="#232F61" href="#j" />
          <use fill="url(#i)" href="#j" />
          <use fill="url(#k)" href="#l" />
        </g>
        <g transform="translate(143)">
          <use fill="#5678FB" href="#m" />
          <use fill="url(#d)" href="#m" />
        </g>
        <g transform="translate(143)">
          <use fill="#FFC62C" href="#n" />
          <use fill="url(#o)" href="#n" />
        </g>
        <g transform="translate(143)">
          <use fill="#FFC62C" href="#p" />
          <use fill="url(#o)" href="#p" />
        </g>
        <path
          fill="url(#q)"
          d="M53.645 65.065c-6.43 3.38-21.554 5.5-26.949-2.056 1.771-1.262 5.493 1.439 14.78-1.046 10.797-2.889 15.02-10.88 23.958-7.032.047 1.363.019 5.16.006 7.575-2.186.013-5.365-.822-11.795 2.559z"
          transform="translate(143)"
        />
        <g transform="translate(143)">
          <use fill="#5678FB" href="#r" />
          <use fill="url(#d)" href="#r" />
        </g>
        <g transform="translate(143)">
          <use fill="#FFC62C" href="#s" />
          <use fill="url(#o)" href="#s" />
        </g>
        <g transform="translate(143)">
          <use fill="#FFC62C" href="#t" />
          <use fill="url(#o)" href="#t" />
        </g>
        <path
          fill="url(#u)"
          d="M43.146 93.491c2.445.681 4.805 1.02 6.801 1.02 1.232 0 2.447-.188 3.626-.533v3.593c-1.18.345-2.394.533-3.626.533-1.996 0-4.356-.338-6.8-1.02v-3.593z"
          transform="translate(143)"
        />
      </g>
    </svg>
  )
}

export default EmptyStateHappy
